import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';

import FormPersona from '../../tramites/formularios/FormPersona';

import insertPersona from '../../../graphql/mutations/persona/insertPersona.graphql';
import updatePersonaPorId from '../../../graphql/mutations/persona/updatePersonaPorId.graphql';
import getPersonaPorId from '../../../graphql/querys/personas/getPersonaPorId.graphql';
import { errorService } from '../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(insertPersona, {
    name: 'createPers',
  }),
  graphql(updatePersonaPorId, {
    name: 'updatePers',
  })
)
class EditarPersona extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      persona: {},
      certificacion: {},
      id_TipoCertificacion: '',
      cantidad: 0,
      step: 0,
      guardado: false,
      loading: true,
    };

    this.props.client
      .query({
        query: getPersonaPorId,
        variables: { _id: this.props.match.params.id },
      })
      .then(res => {
        const persona = res.data.getPersonaPorId;
        this.setState({
          loading: false,
          persona: persona,
        });
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);
        errorService(err, {
          _id: this.props.match.params.id,
        });
        Modal.error({
          title: 'Error en la creacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });

    this.guardarPersona = this.guardarPersona.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  guardarPersona(persona) {
    // console.log(persona);
    this.setState(
      {
        persona: {
          ...this.state.persona,
          ...persona,
        },
      },
      function() {
        let nuevaPersona = this.state.persona;
        delete nuevaPersona.__typename;

        this.props
          .updatePers({
            variables: {
              _id: this.props.match.params.id,
              nuevaPersona: this.state.persona,
            },
          })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            notification.success({
              message: 'Actualizacion Correcta',
              description: 'Se ha registrado los nuevos datos de la persona',
            });

            this.props.history.push('/admin/personas');
          })
          .catch(err => {
            console.log('Error en la actualizacion de la persona');
            console.log(err);
            errorService(err, {
              _id: this.props.match.params.id,
              nuevaPersona: this.state.persona,
            });
            Modal.error({
              title: 'Error en la actualizacion de los datos de la persona',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      }
    );
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Persona</Breadcrumb.Item>
          <Breadcrumb.Item>Editar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Editar Persona
          </h2>
          <br />
          <div style={estiloContent}>
            <FormPersona
              className="formularios"
              onSubmit={this.guardarPersona}
              onAnterior={() => this.props.history.push('/admin/personas')}
              persona={this.state.persona}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(EditarPersona);
